import React, { useContext } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AuthContext, IntlContext } from "context";
import Form, { Mode } from "../Form";
import { Role, Status } from "types/user";
import { ROUTES } from "routes";

const AdAddPage: React.FC = () => {
    const { account, currentRole } = useContext(AuthContext);
    const intl = useContext(IntlContext);

    if (currentRole !== Role.CLIENT) {
        return <Navigate to={ROUTES.ACCOUNT} replace />;
    }

    if (account?.user?.status !== Status.ACTIVE) {
        return <Navigate to={ROUTES.MY_ADS} replace />;
    }

    return (
        <div className="space-y-6 mx-16 my-12">
            <Link
                to={ROUTES.MY_ADS}
                className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 transition-colors hover:text-primary"
            >
                <ArrowLeft className="h-4 w-4" strokeWidth={2.25} />
                {intl.formatMessage("profile.my_ads.back")}
            </Link>

            <div className="rounded-2xl bg-white p-6 shadow-sm sm:p-8">
                <header className="border-b border-gray-100 pb-6">
                    <h2 className="text-2xl font-bold text-gray-900">{intl.formatMessage("profile.my_ads.add.title")}</h2>
                    <p className="mt-1 text-sm text-slate-500">
                        {intl.formatMessage("profile.my_ads.add.description")}
                    </p>
                </header>

                <div className="ad-form-profile mt-8">
                    <Form mode={Mode.ADD} />
                </div>
            </div>
        </div>
    );
};

export default AdAddPage;
